import { useContext } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider.js';
const useCachedPermissions = () => {
  const context = useContext(AuthenticationContext);
  return {
    cachedPermissions: context.cachedPermissions,
    setCachedPermissions: context.setCachedPermissions
  };
};
export { useCachedPermissions as default, useCachedPermissions };